<template>
  <div>
    Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem odit explicabo, minima, dicta ab est accusamus itaque nemo vitae rem praesentium, fugiat id! Neque, quasi, mollitia! Harum iusto officiis fugiat?
  </div>
</template>

<script>
  export default {
    name: 'About'
  }
</script>